import commonFunc from "../common.func";
import constant from "../main.constants";

const P = constant.PERMISSIONS;

const isKycV1Available = () => commonFunc.isKycV1Enabled();

const kycV1Guard =
  (...perms) =>
  (to, from, next) => {
    if (!isKycV1Available()) {
      next({ name: "Home" });
      return;
    }
    if (commonFunc.checkPermissionWithName(P.admin)) {
      next();
      return;
    }
    if (perms.some((p) => commonFunc.checkPermissionWithName(p))) {
      next();
      return;
    }
    next({ name: "Forbidden" });
  };

// KYC v1 (eski: kural/analiz/skor/alarm/rfi) route'ları.
export default [
  {
    path: "/knowYourCustomerList",
    name: "KnowYourCustomerList",
    component: () => import("../views/KnowYourCustomerList.vue"),
    beforeEnter: kycV1Guard(P.kycRule),
  },
  {
    path: "/knowYourCustomerAnalysis/:queryId?",
    name: "KnowYourCustomer",
    component: () => import("../views/KnowYourCustomerAnalysis.vue"),
    beforeEnter: kycV1Guard(P.kycRule),
  },
  {
    path: "/knowYourCustomerAlerts",
    name: "KnowYourCustomerAlert",
    component: () => import("../views/KnowYourCustomerAlerts.vue"),
    beforeEnter: kycV1Guard(P.kycScore),
  },
  {
    path: "/knowYourCustomerAlarms",
    name: "knowYourCustomerAlarm",
    component: () => import("../views/KnowYourCustomerAlarms.vue"),
    beforeEnter: kycV1Guard(P.kycAlarm),
  },
  {
    path: "/knowYourCustomerRfi",
    name: "knowYourCustomerRfi",
    component: () => import("../views/KnowYourCustomerRfis.vue"),
    beforeEnter: kycV1Guard(P.kycRfiManagement),
  },
  {
    path: "/knowYourCustomerAlarmManagement",
    name: "knowYourCustomerAlarmManagement",
    component: () => import("../views/KnowYourCustomerAlarmManagement.vue"),
    beforeEnter: kycV1Guard(P.kycAlarmManagement),
  },
  {
    path: "/kycAlertRuleDetails/:entityKey",
    name: "KycAlertRuleDetails",
    component: () => import("../views/KycAlertRuleDetails.vue"),
    beforeEnter: kycV1Guard(P.kycAlarm),
  },
];
